module.exports = __webpack_public_path__ + "img/152.dbc53876.png";